import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';    
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';           
import * as moment from 'moment';
import { ImportStudent } from '@ascschool/model/school/import-student';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { StudentService } from '@ascschool/services/school/student.service';

@Component({
  selector: 'app-pop-up-import-hoc-sinh',
  templateUrl: './pop-up-import-hoc-sinh.component.html',
  styleUrls: ['./pop-up-import-hoc-sinh.component.scss']
})
export class StudentImportPupupComponent implements OnInit {
  @Input() schoolId: number;
  fileImport: File;
  discoloration: any;
  importStudent = new ImportStudent();
  isImporting: Boolean = false;
  errorMsg: string;
  isDisabled: boolean = false;

  schoolName: string;

  commonFilter: CommonFilter = new CommonFilter();
  isEditMode = false; 
  validateForm!: FormGroup; 
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    private route: ActivatedRoute,
    public utilsService: UtilsService,
    private schoolService: SchoolService,
    private studentService: StudentService,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {
    this.commonFilter.SchoolId = this.schoolId;
    this.schoolService.GetSelectPagingById(this.schoolId).subscribe(res => {
      this.schoolName = res.educationAndTrainingName;
    });
  }
  import() {
    if (this.fileImport) {
      this.isImporting = true;
      this.studentService.importData(this.fileImport, this.commonFilter).subscribe(res => {
         if(res.statusCode == 0){
           this.discoloration = true;
         }
        if (res !== 0 && res !== null){ 
          
          this.importStudent.ketQuaImport = 'Import dữ liệu ' + res.message;
          
        }
        else
          this.importStudent.ketQuaImport = 'Import dữ liệu không thành công!';

        this.isImporting = false;

        this.importStudent.tenFile = '';
        (<HTMLInputElement>document.getElementById('file-selector')).value = '';
        this.fileImport = null

      }, () => {

        this.isImporting = false;
      });
    } else {
      this.msg.warning('Chưa có file');
    }
  }

  suffixFileClick() {
    if (this.importStudent.tenFile == '') this.utilsService.chooseFile();
    else {
      this.importStudent.tenFile = '';
      (<HTMLInputElement>document.getElementById('file-selector')).value = '';
    }
  }

  finishUpload(file: FileList) {
    this.fileImport = file[0];
    this.importStudent.tenFile = file[0].name;
  }

  taiVe() {
    this.studentService.downloadTemplate().subscribe((data) => {
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'Import-NguoiKhuyetTat-' + moment(new Date()).format('DDMMYYHHmmss') + '.xlsx';
      link.click();
    });
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  
  notification(response){
    if (response.statusCode === 0){
      this.msg.success('Cập nhật thông tin: ' + response.message);
    }else{
      this.msg.error('Lỗi: ' + response.message);
    }
  }
}
